/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import { Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { useState, useEffect } from "react";
import PostService from "../../../services/postService";
import ChangeStatusDropdown from "../../dropdowns/postRelated/changeStatusDropdown";


const UpdateChangeStatusModal = ({
    open,
    handleClose,
    setPopupMsg,
    setPopupType,
    setShowPopup,
    post
}) => {
    const { t } = useTranslation();

    const [formValues, setFormValues] = useState({
        changeStatus: null,
    });

    const [selectedChangeStatus, setSelectedChangeStatus] = useState(null);
    const [updateErrors, setUpdateErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);


    const validateForm = () => {
        const newUpdateErrors = {};

        setUpdateErrors(newUpdateErrors);

        return Object.keys(newUpdateErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm() && (selectedChangeStatus)) {
            try {
                setIsLoading(true);

                console.log(formValues);

                console.log(selectedChangeStatus);

                const data = await PostService.updateChangeStatus(post.id, formValues.changeStatus);
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('update');
                    setShowPopup(true);
                    handleClose({ isReaload: true });
                    setFormValues({
                        changeStatus: null
                    });
                    setSelectedChangeStatus(null);
                }

                setUpdateErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setUpdateErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setUpdateErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        if (post) {
            setFormValues({
                changeStatus: post.changeStatus || '',
            });
            setSelectedChangeStatus(post ? t(post.changeStatus) : null);
            setUpdateErrors({});

        }
    }, [post]);

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('updatePost')}
                        </Typography>
                        <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </Box>
                    <Box width={'100%'}>
                        <ChangeStatusDropdown
                            helperText={updateErrors.changeStatus}
                            error={!!updateErrors.changeStatus}
                            setFormValues={setFormValues}
                            isFilter={false}
                            doNotSelectDefault={true}
                            selectedChangeStatus={selectedChangeStatus}
                            setSelectedChangeStatus={setSelectedChangeStatus}
                        />
                    </Box>

                    {updateErrors.general && (
                        <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                            {updateErrors.general}
                        </Typography>
                    )}

                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        mt: updateErrors.general ? 2 : 4
                    }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', width: 140, height: 40 }}
                        >
                            {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <p>{t('update')}</p>
                                    <DriveFileRenameOutlineOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                </Box>
                            }
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default UpdateChangeStatusModal;
